// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.commandPanel[data-v-6c1d5921]{\n    display: flex;\n    width:-webkit-fill-available !important;\n    padding: 6px;\n}\n.commandPanel-menu[data-v-6c1d5921]{\n    display: flex;\n    align-items: center;\n    padding: 0 6px;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
